import type { ReactNode } from 'react';

interface ExclamationProps {
    message: ReactNode;
}

const Exclamation = ({ message }: ExclamationProps) => (
    <span className='exclamation'>
        <span>❗</span>
        <span className='exclamation-message'>{message}</span>
    </span>
);

export default Exclamation;
